const en = {
  // ── Navigation ─────────────────────────────
  nav: {
    dashboard: 'Dashboard',
    workOrders: 'Work Orders',
    customers: 'Customers',
    calendar: 'Calendar',
    invoices: 'Invoices',
    estimates: 'Estimates',
    inventory: 'Inventory',
    team: 'Team',
    reports: 'Reports',
    settings: 'Settings',
    myWork: 'My Work',
    contracts: 'Contracts',
    tracking: 'Tracking',
    csat: 'CSAT',
    leaderboard: 'Leaderboard',
    bookings: 'Bookings',
    dispatch: 'Dispatch',
    more: 'More',
  },

  // ── Common actions ─────────────────────────
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    back: 'Back',
    close: 'Close',
    confirm: 'Confirm',
    loading: 'Loading...',
    saving: 'Saving...',
    noResults: 'No results',
    required: 'Required',
    optional: 'Optional',
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    yes: 'Yes',
    no: 'No',
    or: 'or',
    of: 'of',
    showing: 'Showing',
    rows: 'rows',
    page: 'Page',
    previous: 'Previous',
    next: 'Next',
  },

  // ── Page titles ────────────────────────────
  pages: {
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Business overview',
    },
    workOrders: {
      title: 'Work Orders',
      subtitle: 'Manage service orders',
      new: 'New order',
      detail: 'Order detail',
    },
    customers: {
      title: 'Customers',
      subtitle: 'Manage your customers',
      new: 'New customer',
      detail: 'Customer detail',
    },
    calendar: {
      title: 'Calendar',
      subtitle: 'Planning view',
    },
    invoices: {
      title: 'Invoices',
      subtitle: 'Billing and payments',
      new: 'New invoice',
    },
    estimates: {
      title: 'Estimates',
      subtitle: 'Manage your estimates',
      new: 'New estimate',
    },
    inventory: {
      title: 'Inventory',
      subtitle: 'Materials and stock control',
    },
    team: {
      title: 'Team',
      subtitle: 'Manage your team',
      invite: 'Invite member',
    },
    reports: {
      title: 'Reports',
      subtitle: 'Metrics and analytics',
    },
    settings: {
      title: 'Settings',
      subtitle: 'Configure your account and organization',
    },
  },

  // ── Auth ────────────────────────────────────
  auth: {
    login: 'Sign in',
    register: 'Create account',
    logout: 'Sign out',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    forgotPassword: 'Forgot your password?',
    resetPassword: 'Reset password',
    sendResetLink: 'Send reset link',
    newPassword: 'New password',
    name: 'Name',
    companyName: 'Company name',
    loginTitle: 'Welcome back',
    loginSubtitle: 'Sign in to your WorSaaS account',
    registerTitle: 'Create your account',
    registerSubtitle: 'Start managing your business',
    forgotTitle: 'Recover password',
    forgotSubtitle: "We'll send you a link to reset your password",
    resetTitle: 'New password',
    resetSubtitle: 'Enter your new password',
    continueWithGoogle: 'Continue with Google',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    passwordMinLength: 'Minimum 8 characters',
    invalidCredentials: 'Invalid email or password',
    emailSent: 'Email sent. Check your inbox.',
    passwordChanged: 'Password updated successfully',
  },

  // ── Work Orders ────────────────────────────
  workOrder: {
    status: {
      pending: 'Pending',
      scheduled: 'Scheduled',
      in_progress: 'In Progress',
      completed: 'Completed',
      cancelled: 'Cancelled',
      on_hold: 'On Hold',
    },
    priority: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      urgent: 'Urgent',
    },
    fields: {
      title: 'Title',
      description: 'Description',
      customer: 'Customer',
      assignedTo: 'Assigned to',
      service: 'Service',
      scheduledDate: 'Scheduled date',
      scheduledTime: 'Time',
      priority: 'Priority',
      status: 'Status',
      address: 'Address',
      notes: 'Internal notes',
    },
  },

  // ── Invoices ───────────────────────────────
  invoice: {
    status: {
      draft: 'Draft',
      sent: 'Sent',
      paid: 'Paid',
      overdue: 'Overdue',
      cancelled: 'Cancelled',
    },
    fields: {
      number: 'Number',
      customer: 'Customer',
      issueDate: 'Issue date',
      dueDate: 'Due date',
      subtotal: 'Subtotal',
      tax: 'Tax',
      total: 'Total',
    },
  },

  // ── Settings tabs ──────────────────────────
  settings: {
    tabs: {
      general: 'General',
      services: 'Services',
      checklists: 'Checklists',
      notifications: 'Notifications',
      automations: 'Automations',
      customFields: 'Fields',
      integrations: 'Integrations',
      billing: 'Billing',
    },
    language: {
      title: 'Language',
      subtitle: 'Select the interface language',
    },
  },

  // ── Toasts / feedback ─────────────────────
  toast: {
    saved: 'Saved successfully',
    deleted: 'Deleted successfully',
    created: 'Created successfully',
    updated: 'Updated successfully',
    error: 'An error occurred',
    errorSaving: 'Error saving',
    errorDeleting: 'Error deleting',
    errorLoading: 'Error loading data',
    copied: 'Copied to clipboard',
  },

  // ── Empty states ──────────────────────────
  empty: {
    workOrders: 'No work orders',
    customers: 'No customers',
    invoices: 'No invoices',
    estimates: 'No estimates',
    inventory: 'No inventory items',
    team: 'No team members',
  },
} as const;

export default en;
